/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { Dropdown } from "primereact/dropdown";

export default function DropdownPR({ field, handleBlur, ...props }) {
  return (
    <>
      <Dropdown
        {...field}
        {...props}
        onBlur={(e) => {
          e.target.name = field.name;
          handleBlur(e);
        }}
      />
    </>
  );
}
